module.exports = {
	"pressReleases": [
		{
			"header": "The Swedish tech company Spotin releases a new platform for shopping in editorial content",
			"date": "2020/06/24",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/1/SV_20200624_Svenska%20techbolaget%20Spotin%20o%CC%88ppnar%20ny%20plattform%20fo%CC%88r%20ko%CC%88p%20pa%CC%8A%20redaktionell%20plats%20.pdf"
			}
		},
		{
			"header": "More than 50 Scandinavian brands start collaboration with Spotin to sell from images  ",
			"date": "2020/11/11",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/2/SV_20201111_Adnym%2C%20Go%CC%88trich%2C%20Residus%20och%20Whyred%20och%20ett%2050-tal%20varuma%CC%88rken%20inleder%20samarbete%20med%20Spotin%20fo%CC%88r%20ny%20form%20av%20e-handel%C2%A0%20.pdf",
				"EN": "https://storage.googleapis.com/spotin/doc/pressreleases/2/EN_%202021111_More%20than%2050%20Scandinavian%20brands%20start%20collaboration%20with%20Spotin%20to%20sell%20from%20images%20.pdf"
			}
		},
		{
			"header": "More people have joined Spotin on its journey towards a more open ecommerce market. After the latest funding round, the Swedish-based tech company has brought in several new investors who share their vision of creating a new standard for ecommerce. ",
			"date": "2021/06/11",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/3/SV_20210611_Fler%20vill%20ta%20del%20av%20Spotins%20resa%20mot%20en%20friare%20e-handel.pdf",
				"EN": "https://storage.googleapis.com/spotin/doc/pressreleases/3/EN_20220611_%20More%20people%20have%20joined%20Spotin%20on%20its%20journey%20towards%20a%20more%20open%20ecommerce%20market%C2%A0.pdf"
			}
		},
		{
			"header": "Tomas Granath joins Spotin as Creative Director",
			"date": "2021/06/27",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/4/SV_20210627_Tomas%20Granath%20ga%CC%8Ar%20in%20som%20Creative%20Director%20i%20techbolaget%20Spotin.pdf"
			}
		},
		{
			"header": "Spotin expands - opens an office in Dhaka, Bangladesh ",
			"date": "2021/10/11",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/5/SV_20211011_%20Spotin%20expanderar%20internationellt%20-%20%E2%80%9CHybridkontor%20det%20nya%20normala%E2%80%9D%C2%A0.pdf"
			}
		},
		{
			"header": "Andreas Bergman, most recently from More Digital Studios in Piteå, joins Spotin ",
			"date": "2021/10/21",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/6/SV_20211021_Andreas%20Bergman%20senast%20fra%CC%8An%20More%20Digital%20Studios%20i%20Pitea%CC%8A%2C%20ga%CC%8Ar%20in%20i%20det%20Lulea%CC%8Abaserade%20tillva%CC%88xfo%CC%88retaget%20Spotin.pdf"
			}
		},
		{
			"header": "Tech company Spotin, that wants to revolutionize e-commerce, recruits a new CMO previously from Amazon and Unilever ",
			"date": "2021/11/08",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/7/SV_20211108_Techbolaget%20ska%20revolutionera%20e-handeln%2C%20rekryterar%20ny%20CMO%20tidigare%20fra%CC%8An%20Amazon%20och%20Unilever%C2%A0%C2%A0%C2%A0%C2%A0%20.pdf"
			}
		},
		{
			"header": "Jon Ölmeskog, most recently from Volvo Cars, joins Spotin as a designer",
			"date": "2022/01/25",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/8/SV_20220125_Jon%20O%CC%88lmeskog%2C%20senast%20fra%CC%8An%20Volvo%20Cars%2C%20ga%CC%8Ar%20in%20med%20en%20designerroll%20i%20det%20Lulea%CC%8Abaserade%20techbolaget%20Spotin.pdf"
			}
		},
		{
			"header": "Michel Gokan Khan joins Spotin as CTO",
			"date": "2022/03/03",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/9/SV_20220303_Michel%20Gokan%20Khan%20ga%CC%8Ar%20in%20som%20CTO%20pa%CC%8A%20Spotin%20.pdf"
			}
		},
		{
			"header": "Waqar Ali Subhani left the Thai giant CP group for the tech company Spotin in Luleå ",
			"date": "2022/03/09",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/10/SV_20220309_Waqar%20Ali%20Subhani%2C%20bytte%20thaila%CC%88ndska%20ja%CC%88tten%20CP%20group%20mot%20techbolaget%20i%20Lulea%CC%8A.pdf"
			}
		},
		{
			"header": "Spotin and Bonnierförlagen launch a new way to sell books online",
			"date": "2022/03/25",
			"links": {
				"EN": "https://storage.googleapis.com/spotin/doc/pressreleases/11/EN_20220325_%20Spotin%20and%20Bonnierfo%CC%88rlagen%20launch%20a%20new%20way%20to%20sell%20books%20online%C2%A0.pdf"
			}
		},
		{
			"header": "More and more fashion brands are showing interest in content commerce",
			"date": "2022/04/04",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/12/SV_20220404_Allt%20fler%20modevaruma%CC%88rken%20visar%20intresse%20fo%CC%88r%20content%20commerce%20.pdf"
			}
		},
		{
			"header": "Next big thing in E-com: Making content shoppable on Vogue Scandinavia by Spotin",
			"date": "2022/06/21",
			"links": {
				"EN": "https://storage.googleapis.com/spotin/doc/pressreleases/13/EN_20220621_%20Next%20big%20thing%20in%20E-com%20-%20Making%20content%20shoppable%20on%20Vogue%20Scandinavia%20by%20Spotin.pdf"
			}
		},
		{
			"header": "SportHälsa and Vinsider partners with Spotin to bring friction-free content commerce",
			"date": "2022/10/11",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/14/SV_20221011_%20SportHa%CC%88lsa%20och%20Vinsider%20inga%CC%8Ar%20samarbete%20med%20Spotin%20fo%CC%88r%20att%20erbjuda%20la%CC%88sare%20ett%20nytt%20sa%CC%88tt%20att%20e-handla.pdf",
				"EN": "https://storage.googleapis.com/spotin/doc/pressreleases/14/EN_20221011_%20SportHa%CC%88lsa%20and%20Vinsider%20partners%20with%20Spotin%20to%20bring%20friction-free%20content%20commerce.pdf"
			}
		},
		{
			"header": "Tasteline starts collaboration with Spotin to offer visitors a new type of e-commerce",
			"date": "2022/11/01",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/15/SV_20221101_Tasteline%20ing%C3%A5r%20sammarbete%20med%20Spotin%20och%20erbjuder%20en%20ny%20typ%20av%20ehandel.pdf"
			}
		},
		{
			"header": "Spotin partners with authors and book publishers",
			"date": "2022/11/15",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/16/20221115%20Spotin%20inga%CC%8Ar%20samarbeten%20med%20fo%CC%88rfattare%20och%20organisationer%20.pdf"
			}
		},
		{
			"header": "Spotin is the Next Evolution in Online Shopping",
			"date": "2023/01/19",
			"links": {
				"SE": "https://storage.googleapis.com/spotin/doc/pressreleases/17/SV_20230119_Svenska%20tech-startupens%20vision.pdf",
				"EN": "https://storage.googleapis.com/spotin/doc/pressreleases/17/EN_20230119_Spotin%20is%20the%20Next%20Evolution%20in%20Online%20Shopping.pdf"
			}
		},
		{
			"header": "Spotin Releases Self-service Portal for Sellers and Publishers to Supercharge Content Commerce",
			"date": "2023/09/21",
			"links": {
				"EN": "https://storage.googleapis.com/spotin/doc/pressreleases/18/EN_20230921_Spotin%20Releases%20Self-service%20Portal%20for%20Sellers%20and%20Publishers%20to%20Supercharge%20Content%20Commerce.pdf"
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/pressreleases/pressreleases.json
// module id = 103
// module chunks = 0